<template>
  <div>
    <PendingRequests/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import PendingRequests from '@/components/EmployeePendingRequests.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      PendingRequests
    }
  }
  </script>
  